import { getStaticOptions, __, request } from "../utils";
import $ from "jquery";
import { locationRestFeedbackPost } from "../wp-api";

class FeedbackPointer {
  /* istanbul ignore next */
  constructor(slug, href, $handler) {
    this.slug = void 0;
    this.href = void 0;
    this.$handler = void 0;
    this.slug = slug;
    this.$handler = $handler;
    this.href = href;
    this.init();
  }

  async close(e, skip = false) {
    e.preventDefault(); // Indicate loading

    this.$handler.pointer("widget").find("input, .button").attr("disabled", "disabled");

    if (!skip) {
      const {
        choice,
        note,
        email
      } = this.getValidInput();

      try {
        choice !== "none" && (await request({
          location: locationRestFeedbackPost,
          request: {
            reason: choice,
            note,
            email
          },
          params: {
            slug: this.slug
          }
        }));
      } catch (e) {// Silence is golden.
      } finally {
        // Ignore any errors and redirect
        window.open(this.href, "_self");
      }
    } else {
      window.open(this.href, "_self");
    }
  }

  buttons() {
    const support = $("<a class=\"button\" href=\"#\">".concat(__("Contact support"), "</a>")).click(() => {
      window.open("https://devowl.io/support/", "_blank");
    });
    const skip = $("<a class=\"button\" href=\"#\">".concat(__("Skip & Deactivate"), "</a>")).click(e => {
      this.close(e, true);
    });
    const deactivate = $("<a class=\"hidden button button-primary\" href=\"#\">".concat(__("Deactivate"), "</a>")).click(e => {
      if (this.validate()) {
        this.close(e, false);
      }
    });
    return $('<div class="real-utils-pointer-buttons" />').append(deactivate, skip, support);
  }

  validate() {
    return this.validateNote() && this.validatePrivacy() && this.validateEmail();
  }

  validateNote() {
    const skipNote = $("[name=\"".concat(this.slug, "-skip-note\"]")).is(":checked");
    const noticeNote = $(".notice-".concat(this.slug, "-note"));
    const {
      choice,
      note
    } = this.getValidInput();

    if (!skipNote && !note && ["upgrade-to-pro", "temp", "none"].indexOf(choice) === -1) {
      noticeNote.show();
      return false;
    } else {
      noticeNote.hide();
    }

    return true;
  }

  validatePrivacy() {
    const privacyChecked = $("[name=\"".concat(this.slug, "-privacy\"]")).is(":checked");
    const noticePrivacy = $(".notice-".concat(this.slug, "-privacy"));
    const {
      email
    } = this.getValidInput();

    if (email && !privacyChecked) {
      noticePrivacy.show();
      return false;
    } else {
      noticePrivacy.hide();
    }

    return true;
  }

  validateEmail() {
    const noticeEmail = $(".notice-".concat(this.slug, "-email"));
    const {
      email
    } = this.getValidInput();

    if (email && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email.toLowerCase())) {
      noticeEmail.show();
      return false;
    } else {
      noticeEmail.hide();
    }

    return true;
  }

  getValidInput() {
    const choice = $("[name=\"".concat(this.slug, "-deactivate-choice\"]:checked")).val();
    const note = $("[name=\"".concat(this.slug, "-note\"]")).val();
    const email = note ? $("[name=\"".concat(this.slug, "-email\"]")).val() : "";

    if (!choice && note) {
      return {
        choice: "other",
        note,
        email
      };
    } else if (choice) {
      return {
        choice,
        note,
        email
      };
    }

    return undefined;
  }

  init() {
    const headline = __("Too bad you are leaving");

    const name = getStaticOptions().names[this.slug];

    const desc = __("Please give us feedback why you deactivate <strong>%s</strong>.", name);

    const choices = {
      "upgrade-to-pro": __("Upgrade to PRO Version"),
      "not-working": __("Plugin did not work"),
      "missing-features": __("Not the features I want"),
      incompatible: __("Incompatible with other themes or plugins"),
      "missing-doc": __("Lack of documentation"),
      "found-better-plugin": __("Found a better plugin"),
      temp: __("Temporary deactivation"),
      none: __("I do not want to give feedback"),
      other: __("Other")
    };
    const $widget = this.$handler.pointer({
      pointerClass: "wp-pointer real-utils-feedback-pointer",
      content: "<h3>".concat(headline, "</h3><p>").concat(desc, "</p>\n<fieldset>\n    ").concat(Object.keys(choices).map(choice => "<label class=\"col-2\"><input type=\"radio\" name=\"".concat(this.slug, "-deactivate-choice\" value=\"").concat(choice, "\" /> ").concat(choices[choice], "</label>")).join(""), "\n        <div class=\"clear\"></div>\n        <br />\n    <label class=\"").concat(this.slug, "-section-note\">\n        <strong>").concat(__("What could we do better?"), "</strong>\n        <input type=\"text\" class=\"regular-text\" name=\"").concat(this.slug, "-note\" />\n        <div class=\"notice notice-").concat(this.slug, "-note notice-error notice-alt hidden\"><p>").concat(__("Please enter a text here or check the box below."), "</p></div>\n    </label>\n    <label class=\"").concat(this.slug, "-section-note\">\n        <input type=\"checkbox\" name=\"").concat(this.slug, "-skip-note\" /> ").concat(__("I don't want to add a comment and hence not help to make %s better.", name), "\n    </label>\n    <label class=\"").concat(this.slug, "-section-email\" style=\"display:none\">\n        <br /><strong>").concat(__("Email for answer/solution (optional)?"), "</strong>\n        <input type=\"text\" class=\"regular-text\" name=\"").concat(this.slug, "-email\" />\n        <div class=\"notice notice-").concat(this.slug, "-email notice-error notice-alt hidden\"><p>").concat(__("Please provide a valid email."), "</p></div>\n    </label>\n    <label class=\"").concat(this.slug, "-section-email\" style=\"display:none\">\n        <input type=\"checkbox\" name=\"").concat(this.slug, "-privacy\" /> ").concat(__('I would like to receive an answer for my issue. For this purpose I agree to the data processing of my feedback and my email address. I have read the devowl.io <a href="https://devowl.io/privacy-policy/" target="_blank">privacy policy</a> and agree to it.', name), "\n        <div class=\"notice notice-").concat(this.slug, "-privacy notice-error notice-alt hidden\"><p>").concat(__("If you would like to be contacted by us, please accept the privacy policy. If you prefer not to be contacted, leave the email field blank."), "</p></div>\n    </label>\n</fieldset>"),
      buttons: this.buttons.bind(this)
    }).pointer("open").pointer("widget"); // Listen to changes and show the "Skip & Deactivate" button

    $widget.find("input").on("input", () => {
      const valid = this.getValidInput();
      const isNoneChoice = (valid === null || valid === void 0 ? void 0 : valid.choice) === "none";
      $widget.find(".button:eq(0)").css("display", valid ? "inline-block" : "none"); // .toggleClass does not work as expected, see jQuery bug tracker

      $widget.find(".button:eq(1)").css("display", !valid ? "inline-block" : "none");
      $widget.find(".button:eq(1)").css("display", !valid ? "inline-block" : "none");
      $("[name=\"".concat(this.slug, "-skip-note\"]")).parent().css("display", valid !== null && valid !== void 0 && valid.note ? "none" : "block");
      $(".".concat(this.slug, "-section-email")).css("display", valid !== null && valid !== void 0 && valid.note && !isNoneChoice ? "block" : "none");
      $(".".concat(this.slug, "-section-note")).css("display", isNoneChoice ? "none" : "block");
    });
  }

}

export { FeedbackPointer };